import { FC, Suspense } from 'react';
import { useParams } from 'react-router';
import { PageContainer } from '../../components/page/PageContainer';
import { PageHeader, PageHeaderSize } from '../../components/page/PageHeader';
import { PageSizer } from '../../components/page/PageSizer';
import { useFilesInFolder } from '../../services/graph/hooks/documentHelper';
import strings from './documents.translations';
import { NavPage } from '../../components/page/Breadcrumbs';
import { Loading } from '../site/Loading';
import { FaFile } from 'react-icons/fa';
import { DocumentListSection } from '../../components/oneDrive/DocumentList';
import { useSectionDetails } from '../../services/graph/hooks/category';
import { ContentSection } from '../../components/page/ContentSection';
import { useCategoryDetails } from '../../services/api/hooks/categories';

export const SectionPage: FC = () => {
  const { sectionId } = useParams<'sectionId'>();
  const { categoryId } = useParams<'categoryId'>();
  if (!sectionId || !categoryId) throw new Error('No section id provided');
  const { categoryData } = useCategoryDetails(categoryId);
  const { sectionData, imageUrl } = useSectionDetails(sectionId);

  if (!sectionData) {
    throw Error('No data found for section');
  }

  const breadcrumbs: NavPage[] = [
    {
      name: strings.common.pages.documents,
      to: '/documents'
    },
    {
      name: categoryData.name,
      to: `/documents/categories/${categoryId}`
    },
    {
      name: sectionData.name,
      to: `/documents/categories/${categoryId}/sections/${sectionId}`
    }
  ];

  return (
    <PageContainer>
      <PageHeader
        title={categoryData.name}
        subtitle={sectionData.name}
        description={sectionData.description}
        imageUrl={imageUrl}
        breadcrumbs={breadcrumbs}
        size={PageHeaderSize.LARGE}
      />
      <Suspense fallback={<Loading fullPage={false} />}>
        {sectionData.longDescription && (
          <ContentSection>
            <p>{sectionData.longDescription}</p>
          </ContentSection>
        )}
        <PageSizer className="py-5 flex flex-col gap-10">
          <DocumentListSection
            title={sectionData.name}
            Icon={FaFile}
            filterable
            getDocuments={() => useFilesInFolder(sectionId)}
          />
        </PageSizer>
      </Suspense>
    </PageContainer>
  );
};
